import Card from './Card';

export default {
  install(Vue) {
    Vue.use(Card);
  },
};
